import Flickity from 'flickity';

export default class ScrollingHero {
  constructor(el) {
    this.el = el;
    this.images = this.el.querySelector('[data-ref="scrolling-hero.images"]');
    this.tick = this.tick.bind(this);
    this.scrollSpeed = 0.5;

    if (!this.images) {
      return;
    }

    document.body.classList.add('scrolling-hero');
    this.items = [...this.images.querySelectorAll('[data-ref="scrolling-hero.item"]')];
    this.files = [...this.images.querySelectorAll('img')];

    const files = this.files.map(
      file =>
        new Promise(resolve => {
          if (file.complete) {
            resolve();
            this.test(file);
          } else {
            file.addEventListener('load', () => {
              this.test(file);
              resolve();
            });
          }
        })
    );

    Promise.all(files).finally(() => {
      this.totalItemsWidth = this.items.reduce((prev, next) => prev + next.offsetWidth, 0);

      if (this.items.length > 1 && this.totalItemsWidth > window.innerWidth) {
        this.initSlider();
      } else {
        this.el.classList.add('is-static');
      }
    });
  }

  test(file) {
    if (file.width > file.height) {
      file.parentNode.classList.add('is-horizontal');
    } else {
      file.parentNode.classList.add('is-vertical');
    }
  }

  initSlider() {
    const shouldWrapAround = window.innerWidth < this.totalItemsWidth * 1.5;

    if (!shouldWrapAround) {
      this.el.classList.add('no-wrap');
    }

    this.flickity = new Flickity(this.images, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: shouldWrapAround,
      draggable: true,
      imagesLoaded: true,
      cellAlign: shouldWrapAround ? 'center' : 'left',
      contain: shouldWrapAround ? false : true,
      on: {
        ready: () => {
          setTimeout(() => {
            this.el.classList.add('is-active');
            if (shouldWrapAround) {
              this.isPlaying = true;
              this.raf = window.requestAnimationFrame(this.tick);
              this.items.forEach(item => {
                item.addEventListener('mouseover', () => {
                  this.isPlaying = false;
                });
                item.addEventListener('focusin', () => {
                  this.isPlaying = false;
                });
                item.addEventListener('mouseout', () => {
                  this.isPlaying = true;
                  this.tick();
                });
                item.addEventListener('focusout', () => {
                  this.isPlaying = true;
                  this.tick();
                });
              });
            }
          }, 200);
        },
      },
    });
  }

  tick() {
    if (!this.isPlaying) {
      return;
    }

    this.flickity.x = (this.flickity.x - this.scrollSpeed) % this.flickity.slideableWidth;
    this.flickity.selectedIndex = this.flickity.dragEndRestingSelect();
    this.flickity.updateSelectedSlide();
    this.flickity.settle(this.flickity.x);

    this.raf = window.requestAnimationFrame(this.tick);
  }
}
